export const user = (state) => {
    return state.user
}

export const access_token = (state) => {
    return state.access_token
}
